/*global $, define, dna getParams*/
define('core/factory/TimingFactory',[
    'angular'
], function(angular) {
    'use strict';

    angular.module('dnaApp').factory('TimingInterceptor',['$log',
        function TimingInterceptor($log) {
            var params = getParams();

            var request = function(config) {
                if (params.debug) {
                    config.requestTimestamp = Date.now();
                }
                return config;
            };

            var response = function(response) {
                if (params.debug) {
                    var responseTime = Date.now();
                    $log.debug('Request to: "' + response.config.url + '" took: ' + (responseTime - response.config.requestTimestamp) + ' ms');
                }
                return response;
            };

            return {
                request : request,
                response: response
            };
        }
    ]);
});
